import { BaseCsvParser } from './BaseCsvParser';

/**
 * Parser for Applications CSV data
 */
export class ApplicationsCsvParser extends BaseCsvParser {
  /**
   * Get the list of required columns for applications CSV
   * @returns Array of required column names
   */
  protected getRequiredColumns(): string[] {
    return ['id', 'entity_id', 'job_id', 'status', 'source_type', 'source_name', 'created_at'];
  }

  /**
   * Validate if an application record has all required fields
   * @param record The record to validate
   * @returns True if the record is valid, false otherwise
   */
  protected validateRecord(record: any): boolean {
    return !!(
      record['id'] &&
      record['entity_id'] &&
      record['job_id'] &&
      record['status'] &&
      record['source_type'] &&
      record['source_name'] &&
      record['created_at']
    );
  }

  /**
   * Create an application object from the parsed CSV record
   * @param record The parsed CSV record
   * @param headers The CSV headers (not used in this implementation)
   * @returns The application object
   */
  protected createRecordObject(record: any, headers: string[]): any {
    return {
      id: record['id'],
      entity_id: record['entity_id'],
      job_id: record['job_id'],
      status: record['status'],
      source_type: record['source_type'],
      source_name: record['source_name'],
      created_at: record['created_at']
    };
  }
}
